import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { SearchInput } from '../../components/ui/Input';
import { Activity, Clock, Eye, MousePointer, Share2, Download, TrendingUp, Calendar } from 'lucide-react';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
const sessionData = [{
  date: 'Jan 1',
  sessions: 234,
  avgDuration: 18
}, {
  date: 'Jan 2',
  sessions: 289,
  avgDuration: 22
}, {
  date: 'Jan 3',
  sessions: 312,
  avgDuration: 20
}, {
  date: 'Jan 4',
  sessions: 267,
  avgDuration: 19
}, {
  date: 'Jan 5',
  sessions: 298,
  avgDuration: 21
}, {
  date: 'Jan 6',
  sessions: 245,
  avgDuration: 17
}, {
  date: 'Jan 7',
  sessions: 278,
  avgDuration: 23
}];
const eventData = [{
  event: 'Model Views',
  count: 3247,
  change: '+12%'
}, {
  event: 'Option Views',
  count: 8932,
  change: '+18%'
}, {
  event: 'Option Selections',
  count: 4521,
  change: '+8%'
}, {
  event: 'Share Actions',
  count: 892,
  change: '+15%'
}, {
  event: 'Export Actions',
  count: 456,
  change: '+22%'
}];
const recentSessions = [{
  id: 1,
  user: 'User-8823',
  builder: 'Excel Homes',
  project: 'The Oakwood',
  duration: '24 mins',
  events: 45,
  timestamp: '2 hours ago'
}, {
  id: 2,
  user: 'User-7732',
  builder: 'Schell Brothers',
  project: 'Coastal Living',
  duration: '18 mins',
  events: 32,
  timestamp: '3 hours ago'
}, {
  id: 3,
  user: 'User-5519',
  builder: 'Mattamy Homes',
  project: 'Summit Ridge',
  duration: '31 mins',
  events: 67,
  timestamp: '5 hours ago'
}, {
  id: 4,
  user: 'User-6621',
  builder: 'Excel Homes',
  project: 'Maple Ridge',
  duration: '15 mins',
  events: 28,
  timestamp: '1 day ago'
}];
export function TelemetryPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [timeRange, setTimeRange] = useState('7d');
  const filteredSessions = recentSessions.filter(session => session.user.toLowerCase().includes(searchQuery.toLowerCase()) || session.builder.toLowerCase().includes(searchQuery.toLowerCase()) || session.project.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="space-y-6 max-w-7xl mx-auto" data-id="element-910">
      <div className="flex items-center justify-between" data-id="element-911">
        <div data-id="element-912">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-913">
            Telemetry & Analytics
          </h1>
          <p className="text-slate-500" data-id="element-914">
            Platform usage metrics and event tracking
          </p>
        </div>
        <div className="flex gap-3" data-id="element-915">
          <select value={timeRange} onChange={e => setTimeRange(e.target.value)} className="px-3 py-2 text-sm border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-916">
            <option value="24h" data-id="element-917">Last 24 Hours</option>
            <option value="7d" data-id="element-918">Last 7 Days</option>
            <option value="30d" data-id="element-919">Last 30 Days</option>
            <option value="90d" data-id="element-920">Last 90 Days</option>
          </select>
          <Button variant="outline" data-id="element-921">Export Report</Button>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-922">
        <Card data-id="element-923">
          <CardContent className="flex items-center p-6" data-id="element-924">
            <div className="p-3 bg-primary-50 rounded-lg" data-id="element-925">
              <Activity className="h-6 w-6 text-primary-600" data-id="element-926" />
            </div>
            <div className="ml-4" data-id="element-927">
              <p className="text-sm font-medium text-slate-500" data-id="element-928">
                Total Sessions
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-929">1,923</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-930">
                <TrendingUp className="h-3 w-3 mr-1" data-id="element-931" />
                <span className="font-medium" data-id="element-932">+12%</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-933">
          <CardContent className="flex items-center p-6" data-id="element-934">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-935">
              <Clock className="h-6 w-6 text-slate-600" data-id="element-936" />
            </div>
            <div className="ml-4" data-id="element-937">
              <p className="text-sm font-medium text-slate-500" data-id="element-938">
                Avg Session Time
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-939">20m</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-940">
                <TrendingUp className="h-3 w-3 mr-1" data-id="element-941" />
                <span className="font-medium" data-id="element-942">+8%</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-943">
          <CardContent className="flex items-center p-6" data-id="element-944">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-945">
              <Eye className="h-6 w-6 text-slate-600" data-id="element-946" />
            </div>
            <div className="ml-4" data-id="element-947">
              <p className="text-sm font-medium text-slate-500" data-id="element-948">Total Events</p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-949">18.0k</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-950">
                <TrendingUp className="h-3 w-3 mr-1" data-id="element-951" />
                <span className="font-medium" data-id="element-952">+15%</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-953">
          <CardContent className="flex items-center p-6" data-id="element-954">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-955">
              <MousePointer className="h-6 w-6 text-slate-600" data-id="element-956" />
            </div>
            <div className="ml-4" data-id="element-957">
              <p className="text-sm font-medium text-slate-500" data-id="element-958">
                Avg Events/Session
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-959">9.4</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-960">
                <TrendingUp className="h-3 w-3 mr-1" data-id="element-961" />
                <span className="font-medium" data-id="element-962">+3%</span>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-963">
        <Card data-id="element-964">
          <CardHeader data-id="element-965">
            <CardTitle data-id="element-966">Session Activity</CardTitle>
          </CardHeader>
          <CardContent data-id="element-967">
            <div className="h-[300px] w-full" data-id="element-968">
              <ResponsiveContainer width="100%" height="100%" data-id="element-969">
                <LineChart data={sessionData} data-id="element-970">
                  <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" data-id="element-971" />
                  <XAxis dataKey="date" tick={{
                  fill: '#64748b',
                  fontSize: 12
                }} data-id="element-972" />
                  <YAxis tick={{
                  fill: '#64748b',
                  fontSize: 12
                }} data-id="element-973" />
                  <Tooltip contentStyle={{
                  borderRadius: '8px',
                  border: 'none',
                  boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                }} data-id="element-974" />
                  <Line type="monotone" dataKey="sessions" stroke="#06b6d4" strokeWidth={2} dot={{
                  fill: '#06b6d4'
                }} data-id="element-975" />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-976">
          <CardHeader data-id="element-977">
            <CardTitle data-id="element-978">Event Distribution</CardTitle>
          </CardHeader>
          <CardContent data-id="element-979">
            <div className="space-y-4" data-id="element-980">
              {eventData.map(item => <div key={item.event} className="flex items-center justify-between" data-id="element-981">
                  <div className="flex items-center gap-3" data-id="element-982">
                    <div className="h-10 w-10 rounded-lg bg-slate-100 flex items-center justify-center" data-id="element-983">
                      {item.event === 'Model Views' && <Eye className="h-5 w-5 text-slate-600" data-id="element-984" />}
                      {item.event === 'Option Views' && <Eye className="h-5 w-5 text-slate-600" data-id="element-985" />}
                      {item.event === 'Option Selections' && <MousePointer className="h-5 w-5 text-slate-600" data-id="element-986" />}
                      {item.event === 'Share Actions' && <Share2 className="h-5 w-5 text-slate-600" data-id="element-987" />}
                      {item.event === 'Export Actions' && <Download className="h-5 w-5 text-slate-600" data-id="element-988" />}
                    </div>
                    <div data-id="element-989">
                      <p className="text-sm font-medium text-slate-900" data-id="element-990">
                        {item.event}
                      </p>
                      <p className="text-xs text-green-600" data-id="element-991">
                        {item.change} vs last period
                      </p>
                    </div>
                  </div>
                  <span className="text-2xl font-bold text-slate-900" data-id="element-992">
                    {item.count.toLocaleString()}
                  </span>
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Recent Sessions */}
      <Card noPadding data-id="element-993">
        <CardHeader className="border-b border-slate-200 bg-slate-50" data-id="element-994">
          <div className="flex items-center justify-between" data-id="element-995">
            <CardTitle data-id="element-996">Recent Sessions</CardTitle>
            <SearchInput className="max-w-xs bg-white" placeholder="Search sessions..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-997" />
          </div>
        </CardHeader>

        <div className="overflow-x-auto" data-id="element-998">
          <table className="w-full text-left text-sm" data-id="element-999">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-1000">
              <tr data-id="element-1001">
                <th className="px-6 py-4" data-id="element-1002">User ID</th>
                <th className="px-6 py-4" data-id="element-1003">Builder</th>
                <th className="px-6 py-4" data-id="element-1004">Project</th>
                <th className="px-6 py-4" data-id="element-1005">Duration</th>
                <th className="px-6 py-4" data-id="element-1006">Events</th>
                <th className="px-6 py-4" data-id="element-1007">Timestamp</th>
                <th className="px-6 py-4 text-right" data-id="element-1008">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-1009">
              {filteredSessions.length === 0 ? <tr data-id="element-1010">
                  <td colSpan={7} className="px-6 py-12 text-center text-slate-500" data-id="element-1011">
                    No sessions found matching "{searchQuery}"
                  </td>
                </tr> : filteredSessions.map(session => <tr key={session.id} className="hover:bg-slate-50 transition-colors" data-id="element-1012">
                    <td className="px-6 py-4 font-medium text-slate-900" data-id="element-1013">
                      {session.user}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-1014">
                      {session.builder}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-1015">
                      {session.project}
                    </td>
                    <td className="px-6 py-4" data-id="element-1016">
                      <div className="flex items-center gap-1 text-slate-600" data-id="element-1017">
                        <Clock className="h-4 w-4 text-slate-400" data-id="element-1018" />
                        {session.duration}
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-1019">
                      <Badge variant="neutral" data-id="element-1020">{session.events} events</Badge>
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-1021">
                      <div className="flex items-center gap-1" data-id="element-1022">
                        <Calendar className="h-3 w-3 text-slate-400" data-id="element-1023" />
                        {session.timestamp}
                      </div>
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-1024">
                      <Button variant="ghost" size="sm" data-id="element-1025">
                        View Details
                      </Button>
                    </td>
                  </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}